import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import "./Navbar.css";
import { useSelector } from "react-redux";
import periyaammanIcon from "../../../assets/pictures/periyaamman-icon.webp";
import chinnaammanIcon from "../../../assets/pictures/chinnaamman-icon.webp";
import PwaPromptBanner from "./PwaPromptBanner";
import { useNavigate } from 'react-router-dom';
// Navbar data with submenu structure
const initialNavBarData = [
  {
    label: "முகப்பு",
    url: "/",
  },
  {
    label: "நிகழ்வுகள்",
    url: "/event/calendar",
  },
  {
    label: "வரலாறு",
    url: "",
    submenu: [
      {
        label: "வேளாளர் தோற்றம் குடியேற்றம்",
        url: "/history/VelalarKudiyetram",
      },
      {
        label: "கொங்குநாடு",
        url: "/history/Kongunadu",
      },
      {
        label: "அரைநாடு",
        url: "/history/Arayanadu",
      },
      {
        label: "காஞ்சிமாநதி",
        url: "/history/Kanjimanadhi",
      },
      /* {
         label: "விதரி அத்திப்பாளையம்",
         url: "/history/VithariAthipalayam",
       },
       {
         label: "பெரிய, சின்ன பொன்னாச்சியம்மன் வரலாறு",
         url: "/history/Ponnachiamman",
       },
       {
         label: "பொன்னாச்சியம்மன் திருக்கோயிலும் திருவிழாவும்",
         url: "/history/PonnachiammanTempleAndFunction",
       },
       {
         label: "செம்பூத்தான் குட்டம் வரலாறு",
         url: "/history/SembuthanKulam",
       },
       {
         label: "செம்பூத்தான் குட்டத்தின் கணெயூர்கள்",
         url: "/history/SembuthanKulamKaneyurgal",
       },
       {
         label: "கொங்கு அவனங்களில் செம்பூத்தான் குட்டம்",
         url: "/history/KonguAvanangalilSembuthankulam",
       },
       {
         label: "செம்பூத்தான் குட்டம் கல்வெட்டுகள்",
         url: "/history/SembuthanKulamKalvettukal",
       },
       {
         label: "செம்பூத்தான் குல மாணிக்கி",
         url: "/history/SembuthanKulaManikki",
       },
       {
         label: "புகழ்பாடிய புலவர்கள்",
         url: "/history/PugalpadiyaPulavargal",
       },
       {
         label: "குலகுருக்கள்",
         url: "/history/Kulakurukkal",
       },
       {
         label: "பொன்னாச்சியம்மன் ஊஞ்சற்பாட்டு",
         url: "/history/PonnachiAmmanUnjalPattu",
       },
       {
         label: "சாற்றுக் கவிவாழ்த்து பாடல்",
         url: "/history/SattrukaviValthupa",
       },
       {
         label: "பொன்னாச்சியம்மன் புகழ்மலை",
         url: "/history/PonnachiammanPugalmalai",
       },*/
    ],
  },
  {
    label: "குடமுழுக்கு",
    url: "",
    submenu: [
      {
        label: "பெரிய கோயில்",
        url: "",
        submenu: [
          {
            label: "08-06-2017",
            url: "",
            submenu: [
              {
                label: "நன்றி மடல் 2017",
                url: "/kudamulukku/Kudamulukku2017ThanksNote",
              },
            ],
          },
        ],
      },
      {
        label: "சின்ன கோயில்",
        url: "",
      },
    ],
  },
  {
    label: "தொடர்பு",
    url: "/contactus",
  },
];

// Function to generate menu items
const menuShow = (mItems) => {
  return mItems.map((item, index) => {
    if (item.submenu) {
      return (
        <NavDropdown
          title={item.label}
          key={index}
          className="navbar_dropdown" // Consistent class for dropdown
        >
          {menuShow(item.submenu)}
        </NavDropdown>
      );
    } else {
      return (
        <Nav.Link
          href={item.url}
          key={index}
          className="navbar_link" // Ensure same class as regular links
        >
          {item.label}
        </Nav.Link>
      );
    }
  });
};

const NavMenu = () => {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const user = useSelector((state) => state.user); // Assuming `state.user` stores the user data
  const [navBarData, setNavBarData] = useState(initialNavBarData); // Use state to store the navbar data
  const navigate = useNavigate();
  if (isLoggedIn && !initialNavBarData.some(item => item.label === "எனது கணக்கு👤")) {
    initialNavBarData.push({
      label: "எனது கணக்கு👤",
      url: "/user/profile",
    });
  }
  if (isLoggedIn && !initialNavBarData.some(item => item.label === "நன்கொடை💰")) {
    initialNavBarData.push({
      label: "நன்கொடை💰",
      url: "/user/donations",
    });
  }
  if (isLoggedIn && !initialNavBarData.some(item => item.label === "குடும்பம்👨‍👩‍👧‍👦")) {
    initialNavBarData.push({
      label: "குடும்பம்👨‍👩‍👧‍👦",
      url: "/user/family",
    });
  }
  useEffect(() => {
    // Merge profile data dynamically into navBarData if user is logged in
    let updatedNavBarData = [...initialNavBarData]; // Clone the initialNavBarData array

    if (isLoggedIn) {
      // User is logged in, add profile-related items
      const firstName = user.firstName || user.email;
      updatedNavBarData.push({
        label: `வணக்கம் @ ${firstName}`, // Dynamic greeting
        url: "/user/profile",
        submenu: [

          // Check if the user has the 'FamilyRO' role before adding the submenu item
          ...(user.roles && user.roles.includes('FamilyRO')
            ? [{
              label: "👨‍👩‍👧‍👦 குடும்ப நிர்வாகம்",
              url: "/family",
            }
            ]
            : []),
          // Check if the user has the 'AddressRO' role before adding the submenu item
          ...(user.roles && user.roles.includes('AddressRO')
            ? [
              {
                label: "🏠 முகவரி ",
                url: "/address/admin",
              }
            ]
            : []),

          ...(user.roles && user.roles.includes('DonationRO')
            ? [
              {
                label: "💰 நன்கொடை ",
                url: "/donation",
              }
            ]
            : []),
          ...(user.roles && user.roles.includes('ExpenseRO')
            ? [
              {
                label: "💸 செலவுகள் ",
                url: "/expense",
              }
            ]
            : []),
          ...(user.roles && user.roles.includes('EventsRW')
            ? [
              {
                label: "🎉 நிகழ்வு நிர்வாகம்",
                url: "/event/admin",
              }
            ]
            : []),
          ...(user.roles && user.roles.includes('ContactAdmin')
            ? [
              {
                label: "🎧 தொடர்பு நிர்வாகம்",
                url: "/contact",
              }
            ]
            : []),
          ...(user.roles && user.roles.includes('ConfigRW')
            ? [
              {
                label: "⚙️ கட்டமைப்பு ",
                url: "/config/category",
              }
            ]
            : []),
          {
            label: "📥 செய்திகள்",
            url: "/user/inbox",
          },
          {
            label: "🔒 கடவுச்சொல்லை அமைக்கவும்",
            url: "/user/set-profile-password",
          },
        ],
      });
      updatedNavBarData.push({
        label: "வெளியேறுதல்  (Logout) 👋",
        url: "/auth/logout",

      });
    } else {
      updatedNavBarData.push({
        label: "கணக்கில் உள்நுழைக (Login) 🔑",
        url: "/auth/login",

      });
    }

    // Update the state with the modified navBarData
    setNavBarData(updatedNavBarData);
  }, [isLoggedIn, user]); // Re-run effect when login state or user data changes

  return (
    <div className="navbar_parent">
      <PwaPromptBanner />
      <div className="navbar_logo"
        onClick={() => navigate('/')}
        style={{ cursor: 'pointer' }}>
        <b>ஸ்ரீ பொன்னாச்சி அம்மன் துணை !<br />ஸ்ரீ கருமலையான் துணை !</b>
      </div>
      <Navbar expand="lg">
        <Navbar.Brand href="/">

          <div className="navbar_logo">
            {/* Image inserted here */}
            <img
              src={periyaammanIcon}
              alt="Logo"
              className="navbar_image"
              style={{ maxHeight: '125px', width: 'auto' }}
            />
            <img
              src={chinnaammanIcon}
              alt="Logo"
              className="navbar_image"
              style={{ maxHeight: '125px', width: 'auto' }}
            />

          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="navbar-collapse-center">
          <Nav className="navbar_links">
            {menuShow(navBarData)}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default NavMenu;